import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { Box } from "@mui/material";
function ComboSelect({
  label,
  options,
  value,
  setValue,
  name,
  disabled,
  edit,
  setInputValue,
  inputValue,
  objSelect, //callBack padd objectselected
}) {
  useEffect(() => {
    const findNameSelected = options?.find((option) => option.value === value);

    if (edit) {
      if (findNameSelected) {
        setInputValue(findNameSelected?.label);
      } else {
        setInputValue("");
      }
    }
  }, [value, inputValue]);

  return (
    <Box
      sx={{
        padding: "8px",
      }}
    >
      <Autocomplete
        disablePortal
        disabled={disabled}
        value={options?.find((option) => option.value === value) || null}
        onChange={(event, newValue) => {
          if (objSelect) {
           
            
            objSelect(newValue);
          }
          setValue([name], newValue ? newValue.value : "");
        }}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        isOptionEqualToValue={(option, value) =>
          value === undefined || value === "" || option.id === value.id
        }
        options={options}
        sx={{
          "& .MuiAutocomplete-inputRoot": {
            padding: "1px",
          },
        }}
        renderInput={(params) => <TextField {...params} label={label} />}
      />
    </Box>
  );
}

export default ComboSelect;
